import React from 'react'
import MdDirectionsRun from 'react-icons/lib/md/directions-run'
import styles from './Loading.styl'

class Loading extends React.Component {
	render() {
		return (
			<main className={ styles['main'] }>
				<div className={ styles['icons'] }>
					<MdDirectionsRun className={ styles['one'] } />
					<MdDirectionsRun className={ styles['two'] } />
					<MdDirectionsRun className={ styles['three'] } />
				</div>
			</main>
		)
	}
}

export default Loading



// WEBPACK FOOTER //
// ./src/client/website/components/Loading/Loading.js